import {
  Component,
  ChangeDetectionStrategy,
  inject,
  computed,
} from "@angular/core";
import { DashboardStateService } from "@app/services/dashboard-state.service";
import { KnittingOrder } from "@app/models/dashboard.models";
import { staggerSlideIn } from "@app/animations/stagger-entrance.animation";

const DISPLAY_LIMIT = 6;

@Component({
  selector: "app-closed-knitting-orders",
  templateUrl: "./closed-knitting-orders.component.html",
  styleUrl: "./closed-knitting-orders.component.scss",
  animations: [staggerSlideIn],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ClosedKnittingOrdersComponent {
  private readonly stateService = inject(DashboardStateService);

  readonly orders = computed<KnittingOrder[]>(
    () =>
      this.stateService
        .lastData()
        ?.closedKnittingOrders?.slice(0, DISPLAY_LIMIT) ?? [],
  );

  readonly animationTrigger = computed(() => this.orders());
}
